import React, { useState, useRef } from 'react';
import { Autocomplete, useJsApiLoader } from '@react-google-maps/api';
import styled from 'styled-components';

const libraries = ['places'];

const defaultCenter = { lat: 37.7749, lng: -122.4194 }; // Default to San Francisco

const LocationInput = styled.input`
  width: 100%;
  padding: 10px;
  border-radius: 10px;
  background: #0d1220;
  border: 1px solid #1f2937;
  color: #e5e7eb;
  font-size: 14px;
  
  &:focus {
    outline: none;
    border-color: #5ce9ff;
  }
  
  &::placeholder {
    color: #6b7280;
  }
`;

const LoadingText = styled.div`
  padding: 10px;
  color: #9ca3af;
  font-size: 14px;
  text-align: center;
`;

const LocationSearch = ({ onCoordinatesChange, required, isGoogleMapsLoaded }) => {
  const [location, setLocation] = useState('');
  const autocompleteRef = useRef(null);

  const handlePlaceSelect = () => {
    const place = autocompleteRef.current.getPlace();
    if (place && place.geometry) {
      const newCoordinates = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      };
      const locationName = place.formatted_address;
      setLocation(locationName);

      // Pass both location name and coordinates to the parent
      onCoordinatesChange({ location: locationName, coordinates: newCoordinates });
    }
  };

  if (!isGoogleMapsLoaded) {
    return <LoadingText>Loading location search...</LoadingText>;
  }

  return (
    <Autocomplete
      onLoad={(ref) => (autocompleteRef.current = ref)}
      onPlaceChanged={handlePlaceSelect}
    >
      <LocationInput
        type="text"
        placeholder="Enter a location"
        value={location}
        onChange={(e) => setLocation(e.target.value)}
        required={required}
      />
    </Autocomplete>
  );
};

export default LocationSearch;

